// BRIEF — clapper-board form.
export default function Brief() {
  return (
    <div className="bg-[#0A0908] text-[#FBF6E8]">
      <section className="pt-32 pb-10 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#FBF6E8]/10">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9963E] mb-4">— Index 04 / Send us a brief</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.025em]">A page or two, <span className="italic text-[#C9963E]">no more</span>.</h1>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 lg:px-12 py-16">
        <form className="bg-[#FBF6E8] text-[#0A0908] p-8 lg:p-14 grid grid-cols-2 gap-x-8 gap-y-7" onSubmit={(e) => e.preventDefault()}>
          {/* Clapper-board header */}
          <div className="col-span-2 flex items-center gap-3 border-b-4 border-[#0A0908] pb-3 mb-2">
            <div className="bg-[#0A0908] text-[#FBF6E8] px-3 py-1.5 font-mono text-[10px] tracking-[0.3em] uppercase flex items-center gap-2">
              <span>SC.</span><span className="text-[#C9963E]">01</span>
            </div>
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase">Take · 1 · ROLL · A</span>
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase ml-auto">DIR · PELAGIC</span>
          </div>
          <Field label="Production company / brand" testId="film-brief-co" />
          <Field label="Your name" testId="film-brief-name" />
          <Field label="Email" type="email" testId="film-brief-email" />
          <Field label="Telephone" type="tel" testId="film-brief-tel" />
          <SelectField label="Type of film" testId="film-brief-type" options={['Brand film', 'Documentary', 'Music video', 'Series episode', 'Other']} />
          <SelectField label="Indicative budget" testId="film-brief-budget" options={['£75k — 200k', '£200k — 500k', '£500k — 1m', '£1m — 3m', 'Above £3m']} />
          <div className="col-span-2">
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#0A0908] block mb-2">Brief · two paragraphs</label>
            <textarea data-testid="film-brief-text" rows="6" placeholder="The film, the audience, the deadline — and one or two films you wish ours to remind you of." className="w-full bg-transparent border-b-2 border-[#0A0908]/30 py-3 outline-none focus:border-[#C9963E] resize-none font-serif text-base" />
          </div>
          <div className="col-span-2 flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-[#0A0908]/65 border-t border-[#0A0908]/15 pt-4">
            <span className="bg-[#C9963E] px-2 py-0.5 text-[#0A0908]">ACTION</span>
            <span>Briefs are read by Sasha (EP) within 48 hours.</span>
          </div>
          <button type="button" data-testid="film-brief-submit" className="col-span-2 bg-[#0A0908] text-[#C9963E] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#C9963E] hover:text-[#0A0908] transition-colors w-full sm:w-auto sm:justify-self-start">Send the brief →</button>
        </form>
      </section>
    </div>
  );
}
function Field({ label, type = 'text', testId }) {
  return (
    <div className="col-span-2 sm:col-span-1">
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#0A0908] block mb-2">{label}</label>
      <input data-testid={testId} type={type} className="w-full bg-transparent border-b-2 border-[#0A0908]/30 py-2.5 outline-none focus:border-[#C9963E] font-serif text-base" />
    </div>
  );
}
function SelectField({ label, options, testId }) {
  return (
    <div className="col-span-2 sm:col-span-1">
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#0A0908] block mb-2">{label}</label>
      <select data-testid={testId} className="w-full bg-transparent border-b-2 border-[#0A0908]/30 py-2.5 outline-none focus:border-[#C9963E] font-serif text-base">
        {options.map(o => <option key={o}>{o}</option>)}
      </select>
    </div>
  );
}
